import { DateTimeFormatParse, parseDate } from '@occc-app/lib/date';

import { TimeRangeOption } from './datetime-range-fields.types';

export const getDateRange = (
  inputValue: TimeRangeOption,
  fromKey: string,
  toKey: string,
  fromValue: string | undefined,
  toValue: string | undefined,
) => {
  const result: Record<string, string> = {};
  if (inputValue === 'CUSTOM_RANGE') {
    if (fromValue) {
      result[fromKey] = parseDate(fromValue, DateTimeFormatParse.DateTimeForFilter).toISOString();
    }
    if (toValue) {
      result[toKey] = parseDate(toValue, DateTimeFormatParse.DateTimeForFilter).toISOString();
    }
    return result;
  }
  const timeRanges: Record<Exclude<TimeRangeOption, 'CUSTOM_RANGE'>, number> = {
    LAST_HOUR: 1,
    LAST_6_HOURS: 6,
    LAST_24_HOURS: 24,
  };
  if (inputValue && timeRanges[inputValue]) {
    result[fromKey] = new Date(Date.now() - timeRanges[inputValue] * 60 * 60 * 1000).toISOString();
    result[toKey] = new Date().toISOString();
  }
  return result;
};
